export const parseDate = (
  createdAt: string,
): { date: string; time: string } => {
  const parsedDate = new Date(createdAt);
  const localeDateString = parsedDate.toLocaleString();
  const [date, time] = localeDateString.split(', ');

  return { date, time };
};

export const formatDateInput = (ms?: string | number) => {
  const n = Number(ms);
  if (!Number.isFinite(n)) return '';
  const d = new Date(n);
  if (Number.isNaN(d.getTime())) return '';
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
};

export function formatTimeInput(ms?: string | number) {
  if (ms == null || ms === '') return '';
  const d = new Date(Number(ms));
  const hh = String(d.getHours()).padStart(2, '0');
  const mm = String(d.getMinutes()).padStart(2, '0');
  const ss = String(d.getSeconds()).padStart(2, '0');
  return `${hh}:${mm}:${ss}`;
}

export const isValidDateStr = (s?: string) =>
  !!s && /^\d{4}-\d{2}-\d{2}$/.test(s);
